@if (visible()) {
<div #overlay class="image-preview-overlay">
    <div class="image-preview-container">
        <button (click)="close()" class="close-button" aria-label="Close image preview">
            <app-icon [type]="'x'" [source]="'lucide'" [size]="'sm'" [class]="'text-white'"></app-icon>
        </button>
        <div class="image-wrapper">
            <img [src]="imageUrl()" alt="Preview" class="preview-image" loading="lazy">
        </div>
    </div>
</div>
}
